import { render, staticRenderFns } from "./Aligners.vue?vue&type=template&id=8de4272a&scoped=true"
import script from "./Aligners.vue?vue&type=script&lang=js"
export * from "./Aligners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de4272a",
  null
  
)

export default component.exports